import type { ModuleRoleLevel, UserRole } from '@/lib/types';

const COMPANY_MODULE_ROLES: Record<UserRole, ModuleRoleLevel> = {
  Admin: 'admin',
  Manager: 'manager',
  Inspector: 'inspector',
  Supervisor: 'supervisor',
  User: 'user',
  Viewer: 'viewer',
};

export function companyRoleToModuleRole(role: UserRole): ModuleRoleLevel {
  return COMPANY_MODULE_ROLES[role];
}
